import { createFileRoute } from '@tanstack/react-router';
import { ExchangePage } from '../components/pages/ExchangePage/ExchangePage';
import { z } from 'zod/mini';

const searchSchema = z.object({
  accountId: z.optional(z.string()),
});

export const Route = createFileRoute('/account/exchange')({
  component: ExchangePage,
  validateSearch: searchSchema.parse,
});
